// Role options - values only, labels come from translations
export const roleOptions = [
  'highest_decision_maker',
  // 'board_president',  // Temporarily disabled - will bring back later
  'operations',
  // 'executive_assistant',  // Temporarily disabled - will bring back later
  'administration',
  'finance',
  'accounting',
  'technology',
  'marketing',
  'sales',
  'hr',
  'procurement',
  // Beside procurement, as `jobtitles.Departments` has them, because the
  // distinction is the one a customer gets wrong: a Leiter Logistik runs a
  // warehouse and a fleet, a Leiter Einkauf negotiates with suppliers.
  //
  // It was missing here rather than anywhere else. The department has existed
  // in `internal/jobtitles` since it was split out of procurement, the export
  // prints a label for it, and 6,238 contacts carry it — but this list is what
  // the filter panel and the guide offer, so none of them could be asked for.
  'logistics'
];

/** What `$_` gives us: a lookup that can be told what to say when it misses. */
type Translate = (key: string, options?: { default?: string }) => string;

/**
 * The label a customer should read for a stored role.
 *
 * Roles travel as keys — "technology", "operations", "hr" — because that is
 * what the search matches on and what the assistant is told to return. They
 * were also what the order confirmation printed, so somebody reviewing what
 * they were about to buy read "technology" where the filter panel had said
 * "Leiter/in Technik". This function is the join the translations already
 * supported and nothing used: `getRoleLabel` returned its argument unchanged.
 *
 * A value with no `roles.` entry is shown as it stands rather than as a missing
 * translation. Free-form roles predate the fixed list and still exist in saved
 * selections.
 */
export function getRoleLabel(value: string, t: Translate): string {
  return t(`roles.${value}`, { default: value });
}

export function getRoleValue(label: string): string {
  return label; // Return label as-is
}
